export enum TranslationsEnum {
  English = 0,
  Swedish = 1,
  German = 2,
  Finnish = 3,
  Italian = 4
}